import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

import { RobotoTypography } from "@/shared/components";
import { Goto } from "@/shared/navigation";

export function NotFoundPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
      sx={{
        backgroundColor: "background.default",
        color: "text.primary",
      }}
    >
      <RobotoTypography
        variant="h1"
        gutterBottom
        sx={{ fontSize: "6rem", fontWeight: "bold" }}
      >
        404
      </RobotoTypography>
      <RobotoTypography variant="h4" gutterBottom>
        Page Not Found
      </RobotoTypography>
      <RobotoTypography
        variant="body1"
        paragraph
        sx={{ maxWidth: "500px", mb: 4 }}
      >
        Sorry, the page you are looking for doesn&apos;t exist.
      </RobotoTypography>
      <Box display="flex" gap={2}>
        <Link to={Goto.route.Home} style={{ textDecoration: "none" }}>
          <Button variant="contained" color="secondary" size="large">
            Go to Homepage
          </Button>
        </Link>
        <Button
          color="secondary"
          disabled={window.history.length === 0}
          onClick={() => window.history.back()}
          size="large"
          variant="outlined"
        >
          Go Back
        </Button>
      </Box>
    </Box>
  );
}
